export const XERO = {
  CONTACT_NAME: '*ContactName',
  EMAIL_ADDRESS: 'EmailAddress',
  PO_ADDRESS_LINE_1: 'POAddressLine1',
  PO_ADDRESS_LINE_2: 'POAddressLine2',
  PO_ADDRESS_LINE_3: 'POAddressLine3',
  PO_ADDRESS_LINE_4: 'POAddressLine4',
  PO_CITY: 'POCity',
  PO_REGION: 'PORegion',
  PO_POSTAL_CODE: 'POPostalCode',
  PO_COUNTRY: 'POCountry',

  INVOICE_NUMBER: '*InvoiceNumber',
  REFERENCE: 'Reference',
  INVOICE_DATE: '*InvoiceDate',
  DUE_DATE: '*DueDate',
  TOTAL: 'Total',

  INVENTORY_ITEM_CODE: 'InventoryItemCode',
  DESCRIPTION: '*Description',
  QUANTITY: '*Quantity',
  UNIT_AMOUNT: '*UnitAmount',
  DISCOUNT: 'Discount',

  ACCOUNT_CODE: '*AccountCode',
  TAX_TYPE: '*TaxType',

  TRACKING_NAME_1: 'TrackingName1',
  TRACKING_OPTION_1: 'TrackingOption1',
  TRACKING_NAME_2: 'TrackingName2',
  TRACKING_OPTION_2: 'TrackingOption2',

  CURRENCY: 'Currency',
  BRANDING_THEME: 'BrandingTheme'
}

export const XERO_INVOICE_CSV_COLUMNS = Object.values(XERO)

export function createEmptyXeroInvoiceRow() {
  return XERO_INVOICE_CSV_COLUMNS.reduce((row, column) => {
    row[column] = ''
    return row
  }, {})
}
